<template>
  <!--弹框3 开始-->
  <el-dialog :visible.sync="frameHomeSoldDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter" :customClass="dialogLanguage">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/fail.png" class="frame-big-img"></div>
      <div class="frame-text-hotel-sold wordBreak">
        {{$t('noInventory')}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-goback" @click="cityRouterLink">{{$t('backHome')}}</el-button>
      <el-button type="primary" class="dialog-goon" @click="goToRoom">{{$t('bookAotherRoom')}}</el-button>
    </span>
  </el-dialog>
  <!--弹框3 结束-->
  <!--引入方式-->
  <!-- <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameHomeSold',
  props: ['frameHomeSoldDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: '',
      cityname: '',
      language: this.common.languageSet(this),
      hotelname: '',
      dialogLanguage: 'dialog-en',
      source: 'roompai',
      conver: ''
    }
  },
  watch: {
    language: function (newCur, oldCur) {
      this.getCityIdFun()

      // 图片
      this.dialogLanguage = 'dialog-' + newCur
    }
  },
  created () {
    setInterval(() => {
      this.language = this.common.languageSet(this)
    }, 200)

    if (this.language === 'en') {
      this.dialogLanguage = 'dialog-en'
    } else {
      this.dialogLanguage = 'dialog-zh'
    }
    var query = this.common.linkQuerys
    var params = this.$route.params

    var searchData = localStorage.getItem('searchData')
    if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
      params = JSON.parse(searchData)
    }
    if (JSON.stringify(query) !== '{}') {
      var adult = parseInt(this.common.linkQuerys.adult)
      if (isNaN(adult)) {
        adult = params.adult
      }
      this.adult = adult

      var child = parseInt(this.common.linkQuerys.child)
      if (isNaN(child)) {
        child = params.child
      }
      this.child = child

      var room = parseInt(this.common.linkQuerys.room)
      if (isNaN(room)) {
        room = params.room
      }
      this.room = room

      var start = this.common.linkQuerys.start_date
      if (start === undefined || start === 'undefined' || start === null || start === 'null') {
        if (params.hasOwnProperty('start_date')) {
          start = params.start_date
        } else if (params.hasOwnProperty('checkin')) {
          start = params.checkin
        }
      }
      this.startdate = start

      var end = this.common.linkQuerys.end_date
      if (end === undefined || end === 'undefined' || end === null || end === 'null') {
        if (params.hasOwnProperty('end_date')) {
          end = params.end_date
        } else if (params.hasOwnProperty('checkout')) {
          end = params.checkout
        }
      }
      this.enddate = end
    } else {
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  methods: {
    goToRoom () {
      // 获取数据
      var path = this.common.routePath(this.$route.path)
      if (path.indexOf('HotelDetail') !== -1) {
        window.location.reload()
        return false
      }

      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }

      var searchJson = {'hotelid': this.hotelid, 'region': this.hotelname, 'start_date': this.startdate, 'end_date': this.enddate, 'room': this.room, 'adult': this.adult, 'child': this.child, 'childNums': childNums}
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        searchJson['source'] = this.source
      }
      if (this.conver === 1 || this.conver === '1') {
        searchJson['conver'] = this.conver
      }
      // this.$router.push({name: 'HotelDetail', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'HotelDetail', params: {'querys': newQuerys}})
    },
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.common.linkQuerys
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.common.linkQuerys.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'hotelname': true, 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
        if (this.language === 'zh') {
          this.cityname = this.city.chinese_name
          this.hotelname = this.city.hotelname
        } else {
          this.cityname = this.city.city
          this.hotelname = this.city.hotelname_en
        }
      })
    },
    // 城市跳转
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'frameHomeSold'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
      var startDate = this.startdate
      if (this.startdate === '' || this.startdate === undefined) {
        startDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 1)
      }
      var endDate = this.enddate
      if (this.enddate === '' || this.enddate === undefined) {
        endDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 2)
      }

      var params = this.$route.params
      if (JSON.stringify(params) === '{}') {
        params = this.common.linkQuerys
      }
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      var childNums = '[]'
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
        childNums = params.childNums
      }

      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': params.room, 'adult': params.adult, 'child': params.child, 'childNums': childNums}
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        searchJson['source'] = this.source
      }
      if (this.conver === 1 || this.conver === '1') {
        searchJson['conver'] = this.conver
      }
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      // this.$router.push({name: 'HotelList', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dialog-goback{width: auto; border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;font-weight: 500;font-size: 14px;color: #4F4C4C;cursor:pointer;}
.dialog-goon{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dialog-goback:hover,.dialog-goon:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.textcenter /deep/ .el-dialog{background-position: right bottom; background-color: #fff;background-size: 23%;}
.textcenter /deep/ .dialog-zh{background: url(https://res.roompai.com/static/img/frame/sold-ch.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 23%;}
.textcenter /deep/ .dialog-en{background: url(https://res.roompai.com/static/img/frame/sold-en.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 23%;}
@media screen and (max-width: 1000px) {
.dialog-goback,.dialog-goon{width:100%; margin-bottom: 10px;}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{margin-left: 0;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameHomeSold.vue